/**
 * Format a duration in minutes as "0 min", "25 min" or "1 hr 20 min".
 * Everywhere in the app uses this helper so the format stays consistent.
 */
export function formatMinutes(min) {
  const m = Math.max(0, Math.round(Number(min) || 0));
  if (m < 60) return `${m} min`;
  const hr = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${hr} hr`;
  return `${hr} hr ${rem} min`;
}

export function formatSeconds(seconds) {
  return formatMinutes((Number(seconds) || 0) / 60);
}
